module.exports = __webpack_public_path__ + "static/media/ninja.7379a360.png";